import { Flex, IconArrowRight, Text } from '@cmpsr/components';
import IconCatch from '@/components/icons/icon-catch/icon-catch';
import ActionPlanBadge from '@/app/components/action-plan/components/common/action-plan-badge';
import { InterventionCategoryIcon } from '@/app/components/action-plan/types';
import { formatRiskRound } from '@/utils';

type ActionPlanSummaryInterventionProps = {
  icon: InterventionCategoryIcon;
  text: string;
  badgeValue: string;
  onClick?: () => void;
};

export default function ActionPlanSummaryIntervention({
  icon,
  text,
  badgeValue,
  onClick,
}: ActionPlanSummaryInterventionProps) {
  return (
    <Flex
      direction="row"
      alignItems="center"
      gap="spacer-3"
      backgroundColor="background-light"
      cursor={onClick ? 'pointer' : 'default'}
      onClick={onClick}
      py="2"
    >
      <IconCatch backgroundColor="background-page-03" size="l" icon={icon} alt="intervention icon" />
      <Text variant={{ base: 'text-body-meta-regular', md: 'text-body-regular' }} flex="1">
        {text}
      </Text>
      <ActionPlanBadge text={formatRiskRound(badgeValue)} />
      <IconArrowRight color="text-secondary" />
    </Flex>
  );
}
